// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + "app" + "." + "d4b0ed11" + ".chunk.css";
};